import loadable from "@loadable/component";

const ProductLanding = loadable(() => import("./ProductLanding.page"));

export default { component: ProductLanding };
